import * as yup from "yup";
import { PostSiliconPayload } from "../../types/Silicon";

export const siliconValidationSchema: yup.ObjectSchema<PostSiliconPayload> =
  yup.object({
    batchNumber: yup
      .string()
      .trim()
      .required("Chargennummer ist erforderlich")
      .min(3, "Mindestens 3 Zeichen")
      .test(
        "not-empty",
        "Chargennummer darf nicht leer sein",
        (value) => value !== undefined && value.trim() !== ""
      ),

    expirationDate: yup
      .string()
      .required("Ablaufdatum ist erforderlich")
      .test("not-empty", "Ablaufdatum darf nicht leer sein", (value) => {
        return !!value && value.trim() !== "";
      })
      .test("is-future", "Ablaufdatum muss in der Zukunft liegen", (value) => {
        return value ? new Date(value) > new Date() : false;
      }),
  });
